"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textSizeConstants = exports.iconComponents = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _icons = require("../icons");

var _statusIndicatorConstants = require("./statusIndicatorConstants");

var _core = require("@emotion/core");

var _statusIconsSmall, _statusIconsLarge;

var POSITIVE = _statusIndicatorConstants.STATUS.POSITIVE,
    WARNING = _statusIndicatorConstants.STATUS.WARNING,
    NEGATIVE = _statusIndicatorConstants.STATUS.NEGATIVE,
    NEUTRAL = _statusIndicatorConstants.STATUS.NEUTRAL,
    INFORMATION = _statusIndicatorConstants.STATUS.INFORMATION,
    WAITING = _statusIndicatorConstants.STATUS.WAITING,
    UNAVAILABLE = _statusIndicatorConstants.STATUS.UNAVAILABLE;
var statusIconsSmall = (_statusIconsSmall = {}, (0, _defineProperty2.default)(_statusIconsSmall, POSITIVE, function (_ref) {
  var props = (0, _extends2.default)({}, _ref);
  return (0, _core.jsx)(_icons.IconCheckCircleSmall, (0, _extends2.default)({
    color: "positive",
    title: "Success"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, WARNING, function (_ref2) {
  var props = (0, _extends2.default)({}, _ref2);
  return (0, _core.jsx)(_icons.IconExclamationTriangleSmall, (0, _extends2.default)({
    color: "warning",
    title: "Warning"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, NEGATIVE, function (_ref3) {
  var props = (0, _extends2.default)({}, _ref3);
  return (0, _core.jsx)(_icons.IconExclamationCircleSmall, (0, _extends2.default)({
    color: "negative",
    title: "Error"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, INFORMATION, function (_ref4) {
  var props = (0, _extends2.default)({}, _ref4);
  return (0, _core.jsx)(_icons.IconInformationSmall, (0, _extends2.default)({
    color: "accent2",
    title: "Information"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, WAITING, function (_ref5) {
  var props = (0, _extends2.default)({}, _ref5);
  return (0, _core.jsx)(_icons.IconClockCircleSmall, (0, _extends2.default)({
    color: "accent2",
    title: "Pending"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, UNAVAILABLE, function (_ref6) {
  var props = (0, _extends2.default)({}, _ref6);
  return (0, _core.jsx)(_icons.IconPadlockFillSmall, (0, _extends2.default)({
    color: "accent2",
    title: "Not available"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, NEUTRAL, null), _statusIconsSmall);
var statusIconsLarge = (_statusIconsLarge = {}, (0, _defineProperty2.default)(_statusIconsLarge, POSITIVE, function (_ref7) {
  var props = (0, _extends2.default)({}, _ref7);
  return (0, _core.jsx)(_icons.IconCheckCircle, (0, _extends2.default)({
    color: "positive",
    title: "Success"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, WARNING, function (_ref8) {
  var props = (0, _extends2.default)({}, _ref8);
  return (0, _core.jsx)(_icons.IconExclamationTriangle, (0, _extends2.default)({
    color: "warning",
    title: "Warning"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, NEGATIVE, function (_ref9) {
  var props = (0, _extends2.default)({}, _ref9);
  return (0, _core.jsx)(_icons.IconExclamationCircle, (0, _extends2.default)({
    color: "negative",
    title: "Error"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, INFORMATION, function (_ref10) {
  var props = (0, _extends2.default)({}, _ref10);
  return (0, _core.jsx)(_icons.IconInformationCircle, (0, _extends2.default)({
    color: "accent2",
    title: "Information"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, WAITING, function (_ref11) {
  var props = (0, _extends2.default)({}, _ref11);
  return (0, _core.jsx)(_icons.IconClock, (0, _extends2.default)({
    color: "accent2",
    title: "Pending"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, UNAVAILABLE, function (_ref12) {
  var props = (0, _extends2.default)({}, _ref12);
  return (0, _core.jsx)(_icons.IconPadlockFill, (0, _extends2.default)({
    color: "accent2",
    title: "Not available"
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, NEUTRAL, null), _statusIconsLarge);
var iconComponents = {
  s: statusIconsSmall,
  l: statusIconsLarge
};
exports.iconComponents = iconComponents;
var textSizeConstants = {
  s: {
    fontSize: 'T100'
  },
  l: {
    fontSize: 'T300'
  }
};
exports.textSizeConstants = textSizeConstants;